export const getUserStatus = (
  status: string | null | undefined,
  deactivatedAt?: string | null
) => {
  if (deactivatedAt) return 'Inativo';
  const normalized = (status || '').toString().toUpperCase();
  if (!normalized) return 'Ativo';
  if (normalized === 'FORCE_CHANGE_PASSWORD') return 'Primeiro acesso';
  if (normalized === 'INACTIVE' || normalized === 'INATIVO') return 'Inativo';
  return 'Ativo';
};
